/**
 * String constants for the IA section. Repo has no i18n framework, so these
 * stand in for translation keys: swap-friendly when final copy lands.
 */
export const IA_COPY = {
  sectionTitle: 'Manage Inclusive Access Participation Preference',
  whatIsLink: 'What is an Inclusive Access program?',
  whatIsLinkHref: 'https://www.mheducation.com/highered/inclusive-access',
  whatIsModalTitle: 'What is the Inclusive Access Program?',
  whatIsModalBody:
    'Your school has made the following course materials available through the Inclusive Access program. Opting in to Inclusive Access requires no upfront payment. Instead, you will be charged a discounted price and billed through your student account alongside tuition and fees.\n\nOpting out of Inclusive Access will eliminate your access to your required McGraw Hill course materials, but your progress in the course materials up to this point will be saved.\n\nNote: If you opt-out, you will need to purchase these required course materials individually, at full retail price to regain access.',
  availabilityLabel: 'Availability to Change Preference',
  pillOpen: 'Open',
  pillOpenUntil: (date: string) => `Open until ${date}`,
  pillClosed: 'Closed',
  toggleOptedIn: 'Opted In',
  toggleOptedOut: 'Opted Out',
  updatedLabel: (date: string) => `Last updated ${date}`,
  optOut: {
    title: 'Are you sure you want to opt-out of Inclusive Access for this item?',
    willLose: {
      prefix: 'If you opt-out, ',
      bold: 'you will lose',
      suffix: ':',
      bullets: ['Immediate access to required McGraw Hill course materials', 'Discounted pricing through your school'],
    },
    staysSame: {
      heading: 'What stays the same:',
      bullets: [
        'Your progress in course materials will be saved',
        'You can regain access by purchasing course materials individually at full retail price',
      ],
    },
    isbn10Label: 'ISBN10:',
    isbn13Label: 'ISBN13:',
    formatLabel: 'Format:',
    priceLabel: 'Opt-In price',
    confirmLabel: 'Confirm',
    cancelLabel: 'Cancel',
  },
  optIn: {
    title: 'With Inclusive Access you get:',
    benefits: [
      'A discounted price negotiated by your school for your required course materials',
      'Course materials billed to your student account alongside tuition and fees, requiring no upfront payment',
    ],
    orderHistoryLabel: 'My Account Settings > Order History',
    refundPolicyLabel: 'Refund Policy',
    priceLabel: 'Opt-In price',
    confirmLabel: 'Confirm',
    cancelLabel: 'Cancel',
  },
  warning: {
    optedOutTitle: 'Access to your course materials is no longer available.',
    optedOutBody:
      'To regain access, please visit your course URL or LMS (Blackboard, Canvas, D2L, Moodle, etc.) and purchase your course materials.',
    optedInTitle: 'Avoid double charges:',
    optedInBeforeOrderHistory:
      "Now that you've opted in to Inclusive Access, your course materials will be billed to your student account alongside tuition and fees. If you previously purchased these materials individually, please submit a refund request by visiting ",
    optedInAfterOrderHistory:
      ' to avoid being charged twice. If you have further questions, review the ',
    refundPolicyLabel: 'McGraw Hill Refund Policy',
  },
} as const;

export const IA_TEST_IDS = {
  section: 'ia-section',
  pill: 'ia-pill',
  toggle: 'ia-toggle',
  toggleLabel: 'ia-toggle-label',
  updated: 'ia-updated',
  optInPrice: 'ia-opt-in-price',
  optOutPrice: 'ia-opt-out-price',
  optedInWarning: 'ia-opted-in-warning',
  optedOutWarning: 'ia-opted-out-warning',
  error: 'ia-error',
} as const;
